import * as React from 'react'

import { Box, Form } from '@factorialco/deprecated-design-system'
import _ from 'lodash'

import { observer } from 'mobx-react'

import AvatarUploader from 'modules/core/components/AvatarUploader'
import InlineTooltip from 'modules/core/components/InlineTooltip'
import Email from 'modules/core/components/Inputs/Email'
import Text from 'modules/core/components/Inputs/Text'
import i18n from 'modules/core/lib/i18n'
import companies from 'modules/core/store/collections/companies'
import accesses from 'modules/core/store/collections/users'
import Access, { buildUser } from 'modules/core/store/models/User'

import type UserForm from 'modules/external_users/lib/forms/User'

interface Props {
  form: UserForm
}
interface State {
  existingUser: Access | null | undefined
}

const UserModal = ({ form }: Props) => {
  const [state, setState] = React.useState<State>({
    existingUser: accesses.get(Number(form.get('id').value)),
  })

  const onUserFound = (user: Access | null | undefined) => {
    const firstName = user?.preferredName
    const lastName = user?.lastName
    form.setValues({
      first_name: firstName,
      last_name: lastName,
    })
    setState({
      existingUser: user,
    })
  }

  const existingEmail = () => {
    const email = form.get('email').value
    const existingEmail = state.existingUser ? state.existingUser.attributes.email : null

    return existingEmail === email
  }

  const renderUserFields = (emailExists: boolean) => {
    return (
      <Box width="full" gap="s8">
        <Box width="full" alignItems="center">
          <AvatarUploader avatarField={form.get('avatar')} size="s80" />
        </Box>
        <Box flexDirection="row" gap="s24" background="grey200" padding="s16" paddingTop="s16">
          <Box>
            <Text
              label={_.capitalize(i18n.t('fields.first_name'))}
              field={form.get('first_name')}
              readonly={emailExists}
            />
          </Box>
          <Box>
            <Text
              label={_.capitalize(i18n.t('fields.last_name'))}
              field={form.get('last_name')}
              readonly={emailExists}
            />
          </Box>
        </Box>
      </Box>
    )
  }

  const renderUserExists = () => {
    const companyName = companies.current.attributes.name
    const email = form.get('email').value

    const userInCompany = accesses.find({
      email,
    })

    const tooltip = (key: string, params: Record<string, unknown>) => {
      if (key === 'already_user') {
        return i18n.t('settings.users.already_user', params)
      }

      return i18n.t('settings.users.already_email', params)
    }

    return (
      <InlineTooltip arrow="top" type={userInCompany ? 'wrong' : null}>
        {tooltip(userInCompany ? 'already_user' : 'already_email', { companyName })}
      </InlineTooltip>
    )
  }

  const id = Number(form.get('id').value)
  const user = accesses.get(id) || buildUser()

  return (
    <>
      <Form>
        <Email form={form} user={user} onUserFound={onUserFound} />
        {user.isNew && existingEmail() && renderUserExists()}
      </Form>
      {renderUserFields(user.isNew && existingEmail())}
    </>
  )
}

export default observer(UserModal)
